import React from 'react'
import PropTypes from 'prop-types'
import {
  Container,
  Divider,
  Dropdown,
  Grid,
  Header,
  Image,
  List,
  Menu,
  Segment,
  Icon
} from 'semantic-ui-react'
import MayaLogoImage from '../../../assets/maya_pink_logo.png'
import {VIEW_STATE} from "../../../constants";

import {getLanguageScope} from '../../../helpers'
const _i18n = getLanguageScope('header');

import CONFIG from '../../../config'
import './HeaderView.scss'

class HeaderView extends React.Component {
  constructor(props){
    super(props)
  }

  render(){

    const {view_state, changeViewState} = this.props;

    return (
      <Menu style={{border: 'none'}} stackable={true} borderless={true} icon='labeled' fluid widths={4}>
        <Container>
          <Menu.Item header>
            <Image size='small' src={MayaLogoImage}/>
          </Menu.Item>

          <Menu.Item active={view_state === VIEW_STATE.MARKET} name='shop'
                     onClick={() => changeViewState(VIEW_STATE.MARKET)}>
            <Icon name='shopping basket' />
            {_i18n('shop')}
          </Menu.Item>

          <Menu.Item active={view_state === VIEW_STATE.ACCOUNT} name='account'
                     onClick={() => changeViewState(VIEW_STATE.ACCOUNT)}>
            <Icon name='user' />
            {_i18n('account')}
          </Menu.Item>

          <Menu.Item>
            <Header as='h4'>
              <Icon name='phone' />
              <Header.Content>
                {CONFIG.SUPPORT_NUMBER}
                <Header.Subheader>{_i18n('support')}</Header.Subheader>
              </Header.Content>
            </Header>
          </Menu.Item>

        </Container>
      </Menu>
    )
  }
}

export default HeaderView;



// WEBPACK FOOTER //
// ./src/layouts/Header/components/HeaderView.js